/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_03_Detail_Amateur_2_HeadingInputs */

const en_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What this means for your game`)
};

const es_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué significa esto para tu juego`)
};

const de_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was das für Ihr Spiel bedeutet`)
};

const zh_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这对你的球技意味着什么`)
};

const ar_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ماذا يعني هذا للعبتك`)
};

const fr_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que cela signifie pour votre jeu`)
};

const vi_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều này nghĩa là gì với trò chơi của bạn`)
};

const sw_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maana yake kwa mchezo wako`)
};

const th_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ่งนี้มีความหมายอย่างไรต่อเกมของคุณ`)
};

const bs_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šta to znači za tvoju igru`)
};

const ja_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのゴルフにとっての意味`)
};

const ko_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여러분의 골프에 주는 의미`)
};

const pt_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que isso significa para o seu jogo`)
};

const it_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che cosa significa per il tuo gioco`)
};

const sv_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad det här betyder för ditt spel`)
};

const nl_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat dit betekent voor je spel`)
};

const da_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad det betyder for dit spil`)
};

const nb_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hva dette betyr for spillet ditt`)
};

const fi_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitä tämä merkitsee pelillesi`)
};

const pl_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co to oznacza dla Twojej gry`)
};

const ru_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что это значит для вашей игры`)
};

const tr_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bunun oyununuz için anlamı`)
};

const hi_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपके खेल के लिए इसका क्या मतलब है`)
};

const id_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa artinya bagi permainan Anda`)
};

const ms_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa maknanya bagi permainan anda`)
};

const cs_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co to znamená pro vaši hru`)
};

const el_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τι σημαίνει αυτό για το παιχνίδι σας`)
};

const he_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מה זה אומר למשחק שלכם`)
};

const af_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat dit vir jou spel beteken`)
};

const hu_method_content_step_03_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit jelent ez a játékod számára`)
};

/**
* | output |
* | --- |
* | "What this means for your game" |
*
* @param {Method_Content_Step_03_Detail_Amateur_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_03_detail_amateur_2_heading = /** @type {((inputs?: Method_Content_Step_03_Detail_Amateur_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_03_Detail_Amateur_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "de") return de_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "th") return th_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "it") return it_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "da") return da_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "id") return id_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "el") return el_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "he") return he_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "af") return af_method_content_step_03_detail_amateur_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_03_detail_amateur_2_heading(inputs)
	return en_method_content_step_03_detail_amateur_2_heading(inputs)
});